import { render, staticRenderFns } from "./Appointments.vue?vue&type=template&id=9dad9a9c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Appointments.vue?vue&type=script&lang=js&"
export * from "./Appointments.vue?vue&type=script&lang=js&"
import style0 from "./Appointments.vue?vue&type=style&index=0&id=9dad9a9c&prod&lang=css&"
import style1 from "./Appointments.vue?vue&type=style&index=1&id=9dad9a9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dad9a9c",
  null
  
)

export default component.exports